// extracted by mini-css-extract-plugin
export default {"item":"MenuItem-module__item__8x2D-"};